import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AppProvider from './context/AppProvider';

import './index.scss';

/* global APP_CONFIG */

if( !APP_CONFIG ) {
  throw new Error('APP_CONFIG is not defined. Please supply a configuration.')
}

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <App/>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);